import { CircleX, Search } from "lucide-react"
import DebouncedInput from "./debounced-input"
import If from "../if"

type Props = {
  disabled?: boolean
  value: string
  placeholder: string
  className?: string
  wrapperClassName?: string
  onSearch: (value: string | number) => void
  id?: string
}

const SearchInput = ({
  disabled = false,
  value,
  placeholder,
  onSearch,
  className = "",
  wrapperClassName = "",
  id
}: Props) => (
  <div
    className={`relative lg:max-w-sm text-gray-400 focus-within:text-gray-600 ${wrapperClassName}`}
  >
    <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
      <Search size={20} aria-hidden="true" />
    </div>
    <DebouncedInput
      disabled={disabled}
      id={id}
      placeholder={placeholder}
      value={value ?? ""}
      onChange={onSearch}
      className={`pl-10 ${className}`}
    />

    <If
      condition={value.length > 0}
      then={
        <button
          tabIndex={0}
          className="btn btn-outline-primary absolute right-3 top-3 bg-white"
          onClick={() => onSearch("")}
          type="button"
        >
          <CircleX size={16} />
          <span className="sr-only">Clear search term</span>
        </button>
      }
    />
  </div>
)

export default SearchInput
